import { WidgetStrategyWithConfig } from 'widgets/WidgetRegistry';
import { WidgetCategory } from 'widgets/WidgetCategory';
import CapsuleContainerWidget from 'widgets/tiles/components/CapsuleContainerWidget';
import { capsuleContainerDescription } from 'widgets/tiles/description/capsuleContainerDescription';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';
import { CapsuleContainerWidgetConfigState } from 'widgets/tiles/store/config/CapsuleContainerWidgetConfigState';
import { buildTilesConfigSlice } from 'widgets/tiles/store/config/configSlice';
import { PortfolioSelection } from 'portfolio/PortfolioSelection';
import { SymbolsService } from 'symbols/SymbolsService';

const { initialConfigState } = buildTilesConfigSlice();

export const CapsuleContainerTitle = 'Capsule Container';

export const capsuleContainerWidgetStrategy: WidgetStrategyWithConfig<CapsuleContainerWidgetConfigState> =
    {
        title: CapsuleContainerTitle,
        supportedHosts: ['layout'],
        reactComponentType: CapsuleContainerWidget,
        categories: [WidgetCategory.SINGLE_STOCK],
        description: capsuleContainerDescription,
        portfolioSelectionRequirements: PortfolioSelectionRequirements.None,
        initialConfigState,
        enableTitleEditing: true,
        getTitle,
    };

async function getTitle(
    symbolsService: SymbolsService,
    selection?: PortfolioSelection,
    config?: CapsuleContainerWidgetConfigState
) {
    if (!config) {
        return undefined;
    }

    const { tabTitle, symbol: pinnedSymbol } = config;

    if (!tabTitle) {
        return CapsuleContainerTitle;
    }

    if (pinnedSymbol) {
        return await symbolsService.processTemplate(pinnedSymbol, tabTitle);
    }

    return undefined;
}
